// @flow

import {type RecordFactory, type RecordInstance, Map, Record} from 'immutable';

import type {RequestResponseMapType} from 'app/utils/redux_v2';
import {
  type KBQuestionActionType,
  RECEIVE_KB_ARTICLES_LIST,
  RECEIVE_KB_ARTICLE_DETAIL,
} from '../actions';
import {type KbQuestionType} from '../types';
import {setNormalizedList} from 'app/utils/redux_v2';

type KbQuestionStateShape = RecordInstance<
  RequestResponseMapType<KbQuestionType>
>;

export const KBQuestionStateFactory: RecordFactory<KbQuestionStateShape> =
  Record({
    byId: Map(),
    queries: Map(),
  });

export type RecordOfKBQuestionState = RecordInstance<KbQuestionStateShape>;

export function kbQuestionsReducer(
  state: RecordOfKBQuestionState = KBQuestionStateFactory(),
  action: KBQuestionActionType
): any {
  switch (action.type) {
    case RECEIVE_KB_ARTICLES_LIST: {
      return setNormalizedList(action.query, action.response, state);
    }
    case RECEIVE_KB_ARTICLE_DETAIL: {
      return state.setIn(
        ['byId', action.article.id.toString()],
        action.article
      );
    }

    default:
      return state;
  }
}
